import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 100-16 8 8 0 000 16zm-2-10a2 2 0 113 1.732V16h-2v-4.268A2 2 0 0110 10z" }));
export default createSvgIcon(iconPath, "Staged");
//# sourceMappingURL=StatusStagedIcon.js.map